import { co } from "@fullcalendar/core/internal-common";
import { DocumentDuplicateIcon, MinusCircleIcon } from "@heroicons/react/24/outline";
//import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from "@nextui-org/table";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  User,
  Chip,
  Tooltip,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Button as HeroButton,
} from "@heroui/react";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import {
  CallExternalApi,
  CreateCommanWay,
  GetCommanWay,
  ListCommanWay,
  UpdateBookingCommanWay,
  UpdateCommanWay,
  UploadImageApi,
} from "API/commonApi";
import { AxiosResponse } from "axios";
import { Button, Img } from "components";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import { TrainTrackingModal } from "components/TrainTrackingModal";
import { useFormik } from "formik";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { debounce } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import UseToast from "utils/AfToast";
import handleWheel from "utils/handleOnWheel";
import { get_file_url } from "utils/lib-utils";
import Spinner from "utils/Spinner";
import { AfDataType as ADT } from "utils/TableColumnData";
import { number, object, string } from "yup";

type OptionType = {
  value: number;
  label: string;
};

interface MotherBagState {
  mode?: string;
  data?: { [key: string]: any }; // Adjust the type based on your data structure
  // Add other properties if needed
}

interface ValuesType {
  destination?: { value: string; label: string };
}

const MotherBagOutScan: React.FC = ({}) => {
  let isDisabled = false;
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;

  const [mode, setMode] = useState<any>("");

  const [mbagText, setMbagText] = useState("");
  const [selectedMbagCodes, setSelectedMbagCodes] = useState<string[]>([]);
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [isMainLoading, setIsMainLoading] = useState(false);

  const toggleSelectMbag = (code: string) => {
    if (!code) return;
    setSelectedMbagCodes((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code]
    );
  };

  const openLinkSlipModal = (motherBagCode?: string) => {
    if (selectedMbagCodes.length > 0) {
      let codes = [...selectedMbagCodes];
      if (motherBagCode && !codes.includes(motherBagCode)) {
        codes.push(motherBagCode);
        setSelectedMbagCodes(codes);
      }
      setMbagText(codes.join(","));
    } else if (motherBagCode) {
      setSelectedMbagCodes([motherBagCode]);
      setMbagText(motherBagCode);
    } else if (selectedMotherbagData?.mother_bag_code) {
      setSelectedMbagCodes([selectedMotherbagData.mother_bag_code]);
      setMbagText(selectedMotherbagData.mother_bag_code);
    } else {
      setMbagText("");
    }
    setShowModal(true);
  };

  const [selectedOrigin, setSelectedOrigin] = useState<any>({});
  const [selectedDest, setSelectedDest] = useState<any>({});
  const [selectedMode, setSelectedMode] = useState<any>(null);
  const [branchList, setBranchList] = useState<any[]>([]);

  const [filterStartDt, setFilterStartDt] = useState<any>(moment().subtract(1, "day").startOf("day"));
  const [filterEndDt, setFilterEndDt] = useState<any>(moment().endOf("day"));

  const [motherBagList, setMotherBagList] = useState<any>([]);
  const [motherbagGroupWiseList, setMotherbagGroupWiseList] = useState<any>({});
  const [selectedMotherbag, setSelectedMotherbag] = useState<any>(null);
  const [selectedMotherbagData, setSelectedMotherbagData] = useState<any>({});
  const [motherbagStatusList, setMotherbagStatusList] = useState<any[]>([]);
  const [selectedMotherbagStatus, setSelectedMotherbagStatus] = useState<any>({ value: -1, label: "Select..." });
  const [statusFilter, setStatusFilter] = useState<any>({ value: "", label: "All" });

  const [selectedStatusValues, setSelectedStatusValues] = useState({});
  const [selectedMbagForPrint, setSelectedMbagForPrint] = useState<any>(0);

  // Train tracking modal state
  const [trainTrackingModal, setTrainTrackingModal] = useState<{ isOpen: boolean; trainNo: string; defaultDate?: string }>({ isOpen: false, trainNo: "" });

  // Action menu and status modal state
  const [openActionMenu, setOpenActionMenu] = useState<number | null>(null);
  const [statusUpdateModal, setStatusUpdateModal] = useState<any | null>(null);

  // Edit Info modal state
  const [editInfoModal, setEditInfoModal] = useState<any | null>(null);
  const [editInfoForm, setEditInfoForm] = useState<any>({
    modeOfPkg: { value: 0, label: "Select Mode" },
    airline: { id: 0, name: "Select Airline" },
    flight: { id: 0, name: "Select Flight" },
    vendor: { id: 0, vendor_name: "Select Vendor" },
    mawb: "",
    train_no: "",
    train_date: "",
    dest_train_code: "",
    flight_track_no: "",
    type: { value: 1, label: "Cargo" },
    realWeight: "",
    remark: "",
    refNo: "",
  });

  const [modeOfPkgOptions, set_modeOfPkgOptions] = useState<any>([
    { value: 0, label: "Select Mode" },
    { value: "By Air", label: "By Air" },
    { value: "By Road", label: "By Road" },
    { value: "By Train", label: "By Train" },
  ]);
  const [airlineOptions, set_airlineOptions] = useState<any>([]);
  const [flightOptions, set_flightOptions] = useState<any>([]);
  const [vendorOptions, set_vendorOptions] = useState<any>([]);
  const [deliVendorOptions, set_deliVendorOptions] = useState<any>([]);
  const [typeOptions, set_typeOptions] = useState<any>([
    { value: 1, label: "Cargo" },
    { value: 2, label: "Console" },
  ]);

  const [userDetails, setUserDetails] = useState<any>({});

  const [jioTagLocation, setJioTagLocation] = useState<any>({});

  useEffect(() => {
    const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
    if (Object.keys(userD).length) {
      setUserDetails(userD.state.user);
    }
  }, []);

  const { refetch: mbag_status } = useQuery(["MbagStatusList"], () => GetCommanWay("/admin/mbag_status_list", {}, {}), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        console.log(data.data);
        setMotherbagStatusList(data.data);
      }
    },
  });

  useQuery(["subbranchListApi"], () => ListCommanWay("/admin/subbranch/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        setBranchList(data.data.data);
      }
    },
  });

  const {
    mutate: mutateUpdateMotherBag,
    isLoading: isUpdateMotherBagloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(
    () =>
      UpdateCommanWay({
        url: "/admin/mother_bag/update/" + selectedMotherbag,
        data: {
          outscanDone: true,
          airline: values.airline.id,
          flight: values.flight.id,
          mawb: values.mawb || undefined,
          modeOfPkg: values.modeOfPkg.value,
          realWeight: values.realWeight || undefined,
          remark: values.remark || undefined,
          /*sysWeight: values.sysWeight,
          totalNos: parseInt(values.totalNos),*/
          type: values.type.value,
          vendor: values.vendor.id,
          status: "PENDING",
          outScanPOD: true,
        },
      }),
    {
      onSuccess: (data: any) => {
        console.log(data, data.status == "SUCCESS");
        if (data.status == "SUCCESS") {
          UseToast("Motherbag Outscan Complete", "success");
          resetForm();
          setSelectedMotherbag(null);
          setSelectedMotherbagData({});
          refetchData();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const { handleSubmit, handleBlur, values, handleChange, errors, setValues, setErrors, touched, dirty, setFieldValue, resetForm } =
    useFormik({
      validationSchema: object().shape({
        modeOfPkg: object().required(),
      }),
      initialValues: {
        modeOfPkg: modeOfPkgOptions[0],
        airline: { id: 0, name: "Select Airline", value: 0, label: "" },
        flight: { id: 0, name: "Select Flight", value: 0, label: "" },
        vendor: { id: 0, vendor_name: "Select Vendor", value: 0, label: "" },
        mawb: "",
        sysWeight: "",
        realWeight: "",
        refNo: "",
        totalNos: "",
        remark: "",
        type: typeOptions[0],
      },
      onSubmit: async (values, { resetForm }) => {
        console.log("======> values", values);
        if (selectedMotherbag == null) {
          UseToast("Select Motherbag !", "error");
          return;
        }
        if (values.modeOfPkg.value == 0 || !values.realWeight) {
          UseToast("Select Mode and Weights", "error");
          return;
        }
        mutateUpdateMotherBag(selectedMotherbag);
      },
    });

  useQuery(["airlineApi"], () => ListCommanWay("/admin/airline/list", {}, { paginate: 10000, include: [] }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        set_airlineOptions(data.data.data);
      }
    },
  });

  const { refetch: flightRefetch } = useQuery(
    ["flightApi"],
    () => ListCommanWay("/admin/flight/list", { airline: values.airline.id, isActive: true }, { paginate: 10000, include: [] }),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          set_flightOptions(data.data.data);
          if (values?.modeOfPkg?.value == "By Road" || values?.modeOfPkg?.value == "By Train") {
            setFieldValue("flight", { id: 1016, name: "0" });
          }
        }
      },
    }
  );
  useEffect(() => {
    if (values.airline.id) {
      flightRefetch();
    }
  }, [values.airline.id]);

  useEffect(() => {
    if (values.airline.id) {
      setFieldValue("flight", { id: 0, name: "Select Flight", value: 0, label: "" });
    }
  }, [values.airline.id]);

  useQuery(
    ["vendorApi"],
    () =>
      ListCommanWay(
        "/admin/vendor/list",
        {
          $or: { vendorType: "Forwader", vendor_name: "OTHER" },
        },
        { paginate: 10000, include: [], branchFilter: true }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          set_vendorOptions(data.data.data);
        }
      },
    }
  );

  useQuery(
    ["DeliveryvendorApi"],
    () =>
      ListCommanWay(
        "/admin/vendor/list",
        {
          $or: { vendorType: "PDA", vendor_name: "OTHER" },
        },
        { paginate: 10000, include: [] }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          set_deliVendorOptions(data.data.data);
        }
      },
    }
  );

  const [thirdPartyOpt, setThirdPartyOtp] = useState<any>();
  const [thirdPartyOptions, setThirdPartyOptions] = useState<any>([{ value: 0, label: "Loading..." }]);

  const { refetch: thirdPartyRefetch } = useQuery(
    ["ThirdPartyListApi"],
    () => ListCommanWay("/admin/third_party/list", {}, { paginate: 10000 }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          let opt: any[] = [];
          data.data.data.forEach((p) => {
            opt.push({
              value: p.id,
              label: p.name,
            });
          });
          setThirdPartyOptions(opt);
        }
      },
    }
  );

  const { refetch: refetchData } = useQuery(
    ["MotherBagApi"],
    () =>
      ListCommanWay(
        "/admin/mother_bag/list",
        {
          $or: {
            $and: {
              createdAt: {
                $gte: filterStartDt,
                $lte: filterEndDt,
              },
            },
          },
          subbranch: selectedOrigin?.id || undefined,
          delivery_subbranch: selectedDest?.id || undefined,
          modeOfPkg: selectedMode?.value || undefined,
        },
        { paginate: 10000, include: ["_destination", "_subbranch", "_deliveryVendor", "_delivery_subbranch", "_re_route_city"] }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          setMotherBagList(data.data.data);
          console.log("Motherbag List:", data.data.data);

          const newData = data.data.data.reduce((dateGroups, m) => {
            const date = moment(m.createdAt, "DD-MM-YYYY HH:mm").format("DD/MM/YYYY");
            const destination = m._delivery_subbranch?.branch_name || m._destination?.city_name || "Unknown";

            if (!dateGroups[date]) {
              dateGroups[date] = {};
            }
            if (!dateGroups[date][destination]) {
              dateGroups[date][destination] = [];
            }
            dateGroups[date][destination].push(m);
            return dateGroups;
          }, {});

          console.log("Grouped Data:", newData);
          setMotherbagGroupWiseList(newData);
        }
      },
    }
  );

  const { mutate: addMotherbag_pod } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Motherbag Status Changed", "success");
        resetForm();
        setSelectedMotherbag(null);
        setSelectedMotherbagData({});
        setSelectedMotherbagStatus({ value: -1, label: "Select..." });
        refetchData();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Motherbag Status Change error. Try Again OR Contact Admin!", "error");
    },
  });

  const { mutate: loadMbagTagLocation, isLoading: isLoadingMbagTagLocation } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        console.log(data);
        let loc: any[] = data?.data?.data || [];
        loc.sort((a: any, b: any) => new Date(b.time || "").getTime() - new Date(a.time || "").getTime());
        setJioTagLocation(loc[0]);
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      UseToast("Motherbag Tag Location Update error. Try Again OR Contact Admin!", "error");
    },
  });

  // Edit Info mutation
  const { mutate: updateMotherbagInfo, isLoading: isUpdatingMotherbagInfo } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Motherbag Info Updated", "success");
        setEditInfoModal(null);
        refetchData();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      UseToast("Failed to update motherbag info. Try Again!", "error");
    },
  });

  // Fetch flights for edit modal when airline changes
  const [editFlightOptions, setEditFlightOptions] = useState<any[]>([]);
  const fetchFlightsForEdit = async (airlineId: number) => {
    if (!airlineId) return;
    try {
      const data = await ListCommanWay("/admin/flight/list", { airline: airlineId, isActive: true }, { paginate: 10000, include: [] });
      if (data.status == "SUCCESS") {
        setEditFlightOptions(data.data.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getInput: any = (type, label, value, name, isDisabled, width, valueKey, labelKey) => {
    let ip = <div></div>;

    switch (type) {
      case ADT.NUMBER:
        ip = (
          <div className={`inline-flex items-center gap-2 ${width ? width : "w-auto"}`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">{label}</label>
            <input
              type="number"
              className={`${
                isDisabled ? "bg-gray-300" : ""
              } bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
              placeholder={label}
              name={name}
              value={values[name]}
              onBlur={handleBlur}
              onChange={(e) => {
                if (Number(e.target.value) >= 0) {
                  handleChange(e);
                }
              }}
              onWheel={handleWheel}
              disabled={mode && (mode === "view" || mode === "edit") ? true : isDisabled}
            />
          </div>
        );
        break;
      case ADT.TEXT:
        ip = (
          <div className={`inline-flex items-center gap-2 ${width ? width : "w-auto"}`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">{label}</label>

            <input
              type="text"
              className={`${
                isDisabled ? "bg-gray-300" : ""
              } bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
              placeholder={label}
              name={name}
              value={values[name]?.label !== undefined ? values[name]?.label : values[name]}
              onBlur={handleBlur}
              onChange={handleChange}
              disabled={mode && (mode === "view" || mode === "edit") ? true : isDisabled}
            />
          </div>
        );
        break;
      case ADT.DB:
        ip = (
          <div className={`inline-flex items-center gap-2 ${width ? width : "w-auto"}`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">{label}</label>
            <Select
              className={`${isDisabled ? "bg-gray-300" : ""} bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full `}
              options={value.all}
              onBlur={handleBlur}
              getOptionValue={(x) => (valueKey ? x[valueKey] : x.value)}
              getOptionLabel={(x) => (labelKey ? x[labelKey] : x.label)}
              onChange={(e) => {
                setFieldValue(name, e);
                console.log("Selected:", e);
                if (name == "modeOfPkg" && (e?.value == "By Road" || e?.value == "By Train")) {
                  setFieldValue("airline", { id: 1010, name: "BY ROAD" });
                }
              }}
              name={name}
              value={values[name]}
              isDisabled={mode === "view" ? true : isDisabled}
            />
          </div>
        );
        break;
      case ADT.TEXTAREA:
        break;
      case ADT.DATETIME:
        break;
      case ADT.DATE:
        ip = (
          <div className={`inline-flex items-center gap-2 ${width ? width : "w-auto"}`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">{label}</label>
            <input
              type="date"
              className={`${
                isDisabled ? "bg-gray-300" : ""
              } bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
              placeholder={label}
              name={name}
              value={values[name]}
              onBlur={handleBlur}
              onChange={handleChange}
              disabled={mode && (mode === "view" || mode === "edit") ? true : isDisabled}
            />
          </div>
        );
        break;
      case ADT.FILE:
        break;
      default:
        ip = <></>;
        break;
    }
    return ip;
  };

  const doShowRow = (m: any) => {
    switch (statusFilter.value) {
      case "":
        return true;
        break;
      case "short":
        return m.status == "SHORT";
      case "pending":
        return !m.outscanDone;
        break;
      case "outscan":
        return m.outscanDone && !m.inscanDone ? true : false;
        break;
      case "received":
        return m.status != "SHORT" && m.inscanDone ? true : false;
        break;
    }
  };

  const getModeSvg = (mode) => {
    switch (mode) {
      case "By Train":
        return (
          <svg className="bg-white p-1 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 24 24">
            \{" "}
            <path
              fill="#B8001F"
              d="M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
            />
          </svg>
        );
      case "By Road":
        return (
          <svg className="bg-gray-400 p-2 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 48 48">
            <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
              <path d="m0 0h48v48h-48z" fill="#fff" fillOpacity=".01" />
              <g stroke="#000" strokeWidth="4" transform="translate(6 5.091863)">
                <path d="m5 .90813664-5 35.99999996" />
                <path d="m36.9287415.90813664-4.9643707 35.95523776" transform="matrix(-1 0 0 1 67.928742 0)" />
                <path d="m18 .90813664v6" />
                <path d="m18 29.9081366v7" />
                <path d="m18 14.9081366v7" />
              </g>
            </g>
          </svg>
        );
      case "By Air":
        return (
          <div className="bg-black-900 p-2 rounded-full w-9 h-9">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 512 512" viewBox="0 0 512 512">
              <path
                fill="#08C2FF"
                d="m490.7 0c-21.3 0-42.7 0-53.3 10.7l-85.3 96h-330.8l-21.3 32 234.7 74.7-64 85.3h-96l-32 32 64 21.3v32c.7 11.5 10.7 21.3 21.3 21.3h32l21.3 64 32-32v-96l85.3-64 74.7 234.7 32-21.3v-330.7l96-85.3c10.7-10.7 10.7-32 10.7-53.4 0-10.6-10.7-21.3-21.3-21.3z"
              />
            </svg>
          </div>
        );
      default:
        return mode;
    }
  };

  const printLabel = (data) => {
    setSelectedMbagForPrint(data);
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    if (selected) {
      setPreview(URL.createObjectURL(selected));
    }
  };
  const handleLinkSlipSave = async () => {
    const cleanedMbagText = mbagText
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
      .join(",");

    console.log("Text:", cleanedMbagText);
    console.log("File:", file);
    if (!cleanedMbagText) {
      alert("Please Enter or Select Motherbag No(s)");
      return;
    }
    if (!file) {
      alert("Please Select Slip Image");
      return;
    }

    const formData = new FormData();
    formData.append("files", file);
    formData.append("folder", "image");
    setShowModal(false);
    setIsMainLoading(true);
    try {
      const response = await UploadImageApi(formData);
      console.log(response);
      if (response?.data?.uploadSuccess?.length) {
        let path = response?.data?.uploadSuccess[0].path;
        linkMotherbagSlip({
          url: "/admin/vendorslip/create/",
          data: {
            slip_url: path,
            awb_id: cleanedMbagText,
          },
        });
      } else {
        setIsMainLoading(false);
        alert(response?.data?.message || "Image upload failed");
      }
    } catch (error) {
      setIsMainLoading(false);
      console.error("Error during image upload:", error);
      UseToast("Error uploading image. Please try again.", "error");
    }
  };
  const { mutate: linkMotherbagSlip, isLoading: linkMbagLoading } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      setIsMainLoading(false);
      if (data.status == "SUCCESS") {
        setMbagText("");
        setFile(null);
        setPreview(null);
        setSelectedMbagCodes([]);
        UseToast("Motherbag Slip Link Successful", "success");
        refetchData();
      } else {
        UseToast(data.message || "Failed to link motherbag slip", "error");
      }
    },
    onError: (data: any) => {
      setIsMainLoading(false);
      typeof data === "string" ? UseToast(data, "error") : UseToast(data?.message || "Error linking motherbag slip", "error");
      //UseToast("Motherbag Status Change error. Try Again OR Contact Admin!", "error");
    },
  });
  const linkMotherbag = (data) => {};

  const handlePrint = () => {
    const content = document.getElementById("mbag-slip-outer")?.innerHTML ?? "";
    
    // Remove any existing print iframe
    const existingFrame = document.getElementById("print-frame");
    if (existingFrame) existingFrame.remove();
    
    // Create iframe for printing (works better on mobile)
    const iframe = document.createElement("iframe");
    iframe.id = "print-frame";
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
    
    const iframeDoc = iframe.contentWindow?.document;
    if (!iframeDoc) return;
    
    iframeDoc.open();
    iframeDoc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Motherbag Slip</title>
          <style>
            @page { size: 4in 4in; margin: 0.08in 0.08in 0.08in 0.16in; }
            body { margin: 0; font-family: sans-serif; }
            @media print { 
              body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } 
            }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);
    iframeDoc.close();
    
    // Wait for content to load then print
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      }, 250);
    };
    
    // Fallback trigger
    setTimeout(() => {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    }, 500);
  };

  // Mobile Print via Local Relay
  const PRINT_RELAY_URL = "http://192.168.1.23:8080"; // Change to your relay PC's IP
  
  const handleMobilePrint = async () => {
    if (!selectedMbagForPrint) {
      UseToast("No label selected", "error");
      return;
    }
    
    try {
      const m = selectedMbagForPrint;
      
      // Send structured data - server renders the label (instant!)
      const labelData = {
        destination: m._delivery_subbranch?.branch_name || m._destination?.city_name || '',
        branchCode: m._delivery_subbranch?.branch_code || '',
        origin: m._subbranch?.branch_name || '',
        originContact: m._subbranch?.mobile || '',
        destContact: m._delivery_subbranch?.mobile || '',
        destShortName: m._delivery_subbranch?.sn || '',
        destAddress: m._delivery_subbranch?.address || '',
        motherbagCode: m.mother_bag_code || '',
        totalNos: m.totalNos?.toString() || '',
        sysWeight: m.sysWeight ? Number(m.sysWeight).toFixed(2) : '',
        realWeight: m.realWeight ? Number(m.realWeight).toFixed(2) : '',
        createdAt: m.createdAt || '',
        printerIp: "192.168.1.123",
        printerPort: 9100,
      };
      
      const response = await fetch(`${PRINT_RELAY_URL}/print`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(labelData),
      });
      
      if (response.ok) {
        const result = await response.json();
        UseToast(result.message || "Print sent!", "success");
      } else {
        const err = await response.json();
        UseToast(err.error || "Print failed", "error");
      }
    } catch (error: any) {
      console.error("Mobile print error:", error);
      UseToast("Cannot connect to relay", "error");
    }
  };

  const downloadSlipPopup = async () => {
    document.body.classList.add("inline-all-img");
    try {
      const input1 = document.getElementById("pdf-content1");
      if (!input1) return;
      const canvas = await html2canvas(input1);
      const imgData = canvas.toDataURL("image/png");
      document.body.classList.remove("inline-all-img");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "in",
        format: [4 * 1.25, 4 * 1.25],
      });
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save((selectedMbagForPrint?.mother_bag_code || "Mbag_Slip") + ".pdf");
    } catch {
      document.body.classList.remove("inline-all-img");
    }
  };

  const MotherBagLabel = ({ scale = 1, mdata = motherBagList?.[0] }) => {
    const s = (val) => `${val * scale}px`;

    return (
      <div
        id="pdf-content1"
        style={{
          width: s(384),
          height: s(384),
          border: `${s(2)} solid #000`,
          boxSizing: "border-box",
          padding: s(8),
          fontFamily: "sans-serif",
          position: "relative",
        }}
      >
        {false && (
          <>
            <span style={{ fontSize: s(34), position: "absolute", left: 0, top: 0, lineHeight: 0.9 }}>⚀</span>
            <span style={{ fontSize: s(34), position: "absolute", left: 0, bottom: 0, lineHeight: 0.9 }}>⚁</span>
            <span style={{ fontSize: s(34), position: "absolute", right: 0, top: 0, lineHeight: 0.9 }}>⚂</span>
            <span style={{ fontSize: s(34), position: "absolute", right: 0, bottom: 0, lineHeight: 0.9 }}>⚃</span>
          </>
        )}

        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: s(4),
          }}
        >
          <div></div>
          <div style={{ display: "flex", alignItems: "center", gap: s(10) }}>
            <span style={{ fontSize: s(36), fontWeight: "bold", lineHeight: 1 }}>DEST</span>
            <span style={{ fontSize: s(32), fontWeight: "bold", lineHeight: 1 }}>⟶</span>
            <span style={{ fontSize: s(58), fontWeight: "bold", lineHeight: 1 }}>{mdata?._delivery_subbranch?.branch_code}</span>
          </div>
        </div>

        {/* Sub Labels */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: s(20),
            marginBottom: s(10),
            padding: `${s(5)} 0`,
            borderTop: "1px solid black",
            borderBottom: "1px solid black",
            lineHeight: 1,
          }}
        >
          <div>
            <span>Origin Contact</span>
            <br />
            <strong style={{ display: "inline-block", marginTop: s(5) }}>{mdata?._subbranch?.mobile}</strong>
          </div>
          <div>
            <span>Dest Contact</span>
            <br />
            <strong style={{ display: "inline-block", marginTop: s(5) }}>{mdata?._delivery_subbranch?.mobile}</strong>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: s(14),
            marginBottom: s(10),
          }}
        >
          {/* Weight and Mbag */}
          <div
            style={{
              fontSize: s(18),
              marginRight: s(5),
            }}
          >
            <div>
              <u>To,</u>
            </div>
            <div className="text-sm">
              <b>{mdata?._delivery_subbranch?.sn}</b>
            </div>
            <div className="text-sm">{mdata?._delivery_subbranch?.address}</div>
          </div>

          {/* QR Code Box */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: s(4),
            }}
          >
            <QRCode value={mdata?.mother_bag_code} size={scale * 140} level="M" />
            <span style={{ fontSize: s(20), lineHeight: 1, marginTop: s(5) }}>
              <b>{mdata?.mother_bag_code}</b>
            </span>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
          }}
        >
          <div style={{ fontWeight: "bold" }}>
            <Img src={"/logo.jpg"} style={{ height: s(50) }} />
          </div>
          <div>
            <div style={{ fontSize: s(14), lineHeight: 1, textAlign: "right" }}>
              Org: <strong>{mdata?._subbranch?.branch_name}</strong>
            </div>
            <div style={{ fontSize: s(14), lineHeight: 1, textAlign: "right", marginTop: s(2) }}>
              Manifested: <strong>{mdata?.totalNos || "-"}</strong>
            </div>
            <div style={{ fontSize: s(14), lineHeight: 1, textAlign: "right", marginTop: s(2) }}>
              Actual WT: <strong>{mdata?.realWeight || "-"} KG</strong>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {(isMainLoading || linkMbagLoading) && <Spinner />}

      {(selectedMbagForPrint && (
        <div className="fixed inset-0 bg-black-900 bg-opacity-50 flex items-center justify-center z-50 font-inter">
          <div className="bg-white rounded-2xl shadow-lg  p-6 relative">
            {/* Close Button */}
            <button
              className="absolute top-6 right-6 text-gray-600 hover:text-black bg-gray-300 px-2 text-lg font-bold rounded-md"
              onClick={() => {
                setSelectedMbagForPrint(0);
              }}
            >
              &times;
            </button>

            {/* Title */}
            <h2 className="text-xl font-bold mb-4">Motherbag Slip</h2>

            <div className="my-4" id="mbag-slip-outer">
              <MotherBagLabel scale={1.25} mdata={selectedMbagForPrint} />
            </div>
            {/* Submit Button */}
            <div className="flex gap-2">
              <button onClick={downloadSlipPopup} type="button" className="flex-1 bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
                Download
              </button>
              <button onClick={handlePrint} type="button" className="flex-1 bg-green-600 text-white py-2 rounded hover:bg-green-700">
                Print
              </button>
              <button onClick={handleMobilePrint} type="button" className="px-3 bg-purple-600 text-white py-2 rounded hover:bg-purple-700" title="Mobile Print (via local relay)">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      )) ||
        ""}

      {showModal && (
        <div className="fixed inset-0 bg-black-900 bg-opacity-50 flex items-center justify-center z-50 font-inter p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-6 relative max-h-[90vh] overflow-y-auto">
            {/* Close Button */}
            <button
              type="button"
              className="absolute top-3 right-3 text-gray-500 hover:text-black bg-gray-100 hover:bg-gray-200 w-8 h-8 rounded-full flex items-center justify-center text-xl font-bold transition"
              onClick={() => {
                setShowModal(false);
              }}
            >
              &times;
            </button>

            {/* Title */}
            <div className="mb-4">
              <h2 className="text-xl font-bold text-gray-900">Link Motherbag Slip</h2>
              <p className="text-xs text-gray-500 mt-0.5">
                Upload a vendor slip image and link it to the selected motherbag(s).
              </p>
            </div>

            {/* Selected Motherbags Chips Display */}
            {mbagText.split(",").filter((c) => c.trim()).length > 0 && (
              <div className="mb-3">
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-xs font-semibold text-gray-700">
                    Selected Motherbags ({mbagText.split(",").filter((c) => c.trim()).length}):
                  </span>
                  <button
                    type="button"
                    className="text-xs text-red-500 hover:underline font-medium"
                    onClick={() => {
                      setMbagText("");
                      setSelectedMbagCodes([]);
                    }}
                  >
                    Clear All
                  </button>
                </div>
                <div className="flex flex-wrap gap-1.5 max-h-28 overflow-y-auto p-2 bg-gray-50 rounded-lg border border-gray-200">
                  {mbagText
                    .split(",")
                    .map((c) => c.trim())
                    .filter((c) => c)
                    .map((code) => (
                      <span
                        key={code}
                        className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded-full border border-blue-200"
                      >
                        {code}
                        <button
                          type="button"
                          className="hover:text-red-600 font-bold ml-0.5 text-sm leading-none"
                          onClick={() => {
                            const updatedCodes = mbagText
                              .split(",")
                              .map((c) => c.trim())
                              .filter((c) => c && c !== code);
                            setMbagText(updatedCodes.join(","));
                            setSelectedMbagCodes((prev) => prev.filter((c) => c !== code));
                          }}
                        >
                          &times;
                        </button>
                      </span>
                    ))}
                </div>
              </div>
            )}

            {/* Comma-separated Motherbag Input (Editable) */}
            <div className="mb-4">
              <label className="block text-xs font-semibold text-gray-700 mb-1">
                Motherbag Code(s) (comma-separated)
              </label>
              <textarea
                rows={2}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="e.g. MBAG001, MBAG002, MBAG003"
                value={mbagText}
                onChange={(e) => {
                  setMbagText(e.target.value);
                  const codes = e.target.value
                    .split(",")
                    .map((c) => c.trim())
                    .filter((c) => c);
                  setSelectedMbagCodes(codes);
                }}
              />
            </div>

            {/* File Input */}
            <div className="mb-4">
              <label className="block text-xs font-semibold text-gray-700 mb-1">
                Select Slip Image <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                accept="image/*"
                className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 cursor-pointer border border-gray-300 rounded-lg p-1.5"
                onChange={handleFileChange}
              />
            </div>

            {/* Image Preview */}
            {preview && (
              <div className="mb-4 relative border rounded-lg p-1 bg-gray-50">
                <img src={preview} alt="Preview" className="w-full max-h-48 object-contain rounded" />
                <button
                  type="button"
                  className="absolute top-2 right-2 bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs shadow hover:bg-red-700"
                  onClick={() => {
                    setFile(null);
                    setPreview(null);
                  }}
                >
                  &times;
                </button>
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="w-1/3 bg-gray-200 text-gray-800 py-2.5 rounded-lg font-medium hover:bg-gray-300 transition text-sm"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleLinkSlipSave}
                disabled={isMainLoading || linkMbagLoading}
                className="w-2/3 bg-blue-600 text-white py-2.5 rounded-lg font-medium hover:bg-blue-700 transition disabled:opacity-50 flex items-center justify-center gap-2 shadow text-sm"
              >
                {isMainLoading || linkMbagLoading ? (
                  <>
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                    Uploading & Linking...
                  </>
                ) : (
                  "Upload & Link Slip"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between font-inter mt-2 mb-4 mx-4">
        <h1 className="text-2xl font-black px-2 py-1 underline">Mother Bag Out Scan</h1>

        <div className="flex items-center justify-center gap-3">
          <div className={` items-center gap-2 w-48`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">Origin</label>
            <Select
              className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-0`}
              options={branchList}
              isClearable={true}
              getOptionValue={(e: any) => {
                return e.id;
              }}
              getOptionLabel={(e: any) => {
                return e.branch_name;
              }}
              onChange={(e: any) => {
                setSelectedOrigin(e);
              }}
            />
          </div>
          <div className={` items-center gap-2 w-48`}>
            <label className="text-sm font-semibold text-gray-900">Destination</label>
            <Select
              className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-0`}
              options={branchList}
              isClearable={true}
              getOptionValue={(e: any) => {
                return e.id;
              }}
              getOptionLabel={(e: any) => {
                return e.branch_name;
              }}
              onChange={(e: any) => {
                setSelectedDest(e);
              }}
            />
          </div>
          <div className={` items-center gap-2 w-48`}>
            <label className="text-sm font-semibold text-gray-900">Mode</label>
            <Select
              className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-0`}
              options={modeOfPkgOptions.slice(1)}
              isClearable={true}
              getOptionValue={(e: any) => {
                return e.value;
              }}
              getOptionLabel={(e: any) => {
                return e.label;
              }}
              onChange={(e: any) => {
                setSelectedMode(e);
              }}
            />
          </div>

          <AfDateRangePicker
            startDate={filterStartDt.format("YYYY-MM-DD")}
            endDate={filterEndDt.format("YYYY-MM-DD")}
            setStartDate={(e: any) => {
              setFilterStartDt(moment(e).startOf("day"));
            }}
            setEndDate={(e: any) => {
              setFilterEndDt(moment(e).endOf("day"));
            }}
            label="Date Range"
            page="motherbag"
          />

          <Button
            type="button"
            className="rounded-md px-2 py-2.5 text-sm font-medium text-white bg-blue-500 border hover:bg-opacity-60 focus:z-10"
            onClick={refetchData}
          >
            Search
          </Button>

          <div className="w-36 ml-10">
            <Select
              className={`flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block `}
              options={[
                { value: "", label: "All" },
                { value: "pending", label: "Pending" },
                { value: "outscan", label: "Outscan" },
                { value: "short", label: "Short" },
                { value: "received", label: "Received" },
              ]}
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e);
              }}
              menuPortalTarget={document.body}
            />
          </div>
        </div>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
        className="font-"
      >
        <div className="px-2 font-inter">
          {Object.entries(motherbagGroupWiseList).map(([date, destinations]: any, i) => {
            const allBagsInDate = (Object.values(destinations) as any[]).flat();
            const visibleBagsInDate = allBagsInDate.filter((m: any) => doShowRow(m) && m.mother_bag_code);
            const isAllDateSelected =
              visibleBagsInDate.length > 0 &&
              visibleBagsInDate.every((m: any) => selectedMbagCodes.includes(m.mother_bag_code));

            return (
              /* 8C00FF, 70B2B2, B7B89F, FFC400, DEDED1, B0CE88 */
              <div key={date} className="mb-6 pt-2 pb-[1px] rounded-lg bg-[#DEDED1] ">
                <div className="flex-1">
                  <div className="mb-2 px-2">
                    <h4 className="text-lg font-bold ">Date: {date}</h4>
                    <Table className="bg-white- p-1 rounded-md" isCompact removeWrapper>
                      <TableHeader className="text-center bg-black-900 text-white">
                        <TableColumn className="bg-black-900 text-white py-2 px-2 print:hidden w-10 text-center">
                          <input
                            type="checkbox"
                            className="w-4 h-4 cursor-pointer accent-blue-600 rounded align-middle"
                            checked={isAllDateSelected}
                            onChange={(e) => {
                              const codes = visibleBagsInDate.map((m: any) => m.mother_bag_code);
                              if (e.target.checked) {
                                setSelectedMbagCodes((prev) => Array.from(new Set([...prev, ...codes])));
                              } else {
                                setSelectedMbagCodes((prev) => prev.filter((c) => !codes.includes(c)));
                              }
                            }}
                          />
                        </TableColumn>
                        <TableColumn className="bg-black-900 text-white py-2 px-2 print:hidden">-</TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 text-center">Added On</TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 text-center">Motherbag No</TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 text-center">Origin</TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 text-center">Destination</TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 text-center">Mode</TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 text-center">
                          No of
                          <br />
                          Awb
                        </TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 text-center">
                          Total
                          <br />
                          WT
                        </TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 text-center">Status</TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 print:hidden text-center">Action</TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 print:hidden text-center">Last Reason</TableColumn>
                        <TableColumn className="bg-black-900 text-white px-1 print:hidden text-center">...</TableColumn>
                      </TableHeader>
                      <TableBody>
                        {Object.entries(destinations).map(([destination, bags]: any, i2) => (
                          <>
                            {!statusFilter.value && (
                              <TableRow key={i + "blank-" + i2} className="bg-[#DEDED1]">
                                <TableCell className="text-xs p-0" colSpan={13}>
                                  &nbsp;
                                </TableCell>
                              </TableRow>
                            )}

                            {bags.map(
                              (m) =>
                                doShowRow(m) && (
                                  <TableRow
                                    key={i + "-" + m.id}
                                    className={`border-t border-black-900_0c ${
                                      selectedMbagCodes.includes(m.mother_bag_code) ? "!bg-blue-100 ring-1 ring-blue-400" : ""
                                    } ${m.id == selectedMotherbag && "bg-blue-200"} ${
                                      m.status == "SHORT"
                                        ? "bg-teal-600 text-white"
                                        : m.inscanDone
                                        ? "bg-green-500"
                                        : m.outscanDone
                                        ? "bg-yellow-100"
                                        : "bg-red-400"
                                    } ${m.id == selectedMotherbag && "bg-blue-200"}`}
                                  >
                                    <TableCell className="text-center print:hidden px-2 rounded-l-md">
                                      <input
                                        type="checkbox"
                                        className="w-4 h-4 cursor-pointer accent-blue-600 rounded align-middle"
                                        checked={selectedMbagCodes.includes(m.mother_bag_code)}
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          toggleSelectMbag(m.mother_bag_code);
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell>
                                      {m.outscanDone ? (
                                        <p className="py-1 px-1 text-sm">-</p>
                                      ) : m.id == selectedMotherbag ? (
                                        <p className="py-1 px-1 text-sm">Selected</p>
                                      ) : (
                                        <>
                                          <Button
                                            type="button"
                                            className="rounded-md px-2 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                                            onClick={() => {
                                              setSelectedMotherbag(m.id);
                                              setSelectedMotherbagData(m);
                                              resetForm();
                                            }}
                                          >
                                            Select
                                          </Button>

                                          {!m.outscanDone && (
                                            <Button
                                              type="button"
                                              className="rounded-md px-2 py-1 text-sm font-medium text-white bg-blue-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 ml-2"
                                              onClick={() => {
                                                navigate("/mother_bag/add", {
                                                  state: {
                                                    mode: "edit",
                                                    data: m,
                                                  },
                                                });
                                              }}
                                            >
                                              Edit
                                            </Button>
                                          )}
                                        </>
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      <div className="leading-none">
                                        <span className="whitespace-nowrap font-semibold">
                                          {moment(m.createdAt, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY")}
                                        </span>
                                        <br />
                                        <span className="whitespace-nowrap text-xs font-semibold">
                                          {moment(m.createdAt, "DD-MM-YYYY HH:mm").format("HH:mm")}
                                        </span>
                                      </div>
                                    </TableCell>
                                    <TableCell className="px-2 whitespace-nowrap text-center">
                                      <button
                                        type="button"
                                        onClick={async () => {
                                          await navigator.clipboard.writeText(m.mother_bag_code || "-");
                                          UseToast("Copied!");
                                        }}
                                      >
                                        <DocumentDuplicateIcon className="h-5 -mb-1 mr-2" />
                                      </button>
                                      <span
                                        className="cursor-pointer hover:underline font-semibold font-opensans"
                                        onClick={() => {
                                          navigate("/mother_bag/add", {
                                            state: {
                                              mode: "view",
                                              data: m,
                                            },
                                          });
                                        }}
                                      >
                                        {m.mother_bag_code}
                                      </span>
                                    </TableCell>
                                    <TableCell className=" text-center">{m._subbranch?.branch_name}</TableCell>
                                    <TableCell className=" text-center">
                                      {(m._delivery_subbranch?.branch_name || m._destination?.city_name) === "NON-BRANCH" ? (
                                        <div className="leading-tight">
                                          <span className="text-[11px] font-semibold bg-orange-200 text-orange-800 px-1 rounded">NON-BRANCH</span>
                                          <br />
                                          <span className="font-semibold">{m._re_route_city?.city_name}</span>
                                        </div>
                                      ) : (
                                        m._delivery_subbranch?.branch_name || m._destination?.city_name
                                      )}
                                    </TableCell>
                                    <TableCell className="py-0 text-center">{getModeSvg(m.modeOfPkg)}</TableCell>
                                    <TableCell className="text-center">{m.totalNos}</TableCell>
                                    <TableCell className="text-center">{Number(m.sysWeight).toFixed(2)}</TableCell>
                                    <TableCell className="text-center">
                                      {m.status == "SHORT" ? "Short" : m.inscanDone ? "Received" : m.outscanDone ? "Outscan" : "Pending"}
                                    </TableCell>
                                    <TableCell className="text-center print:hidden whitespace-nowrap px-2">
                                      {!m?.VendorSlips?.length ? (
                                        <button
                                          type="button"
                                          className="inline-block rounded-md px-2 py-1 text-sm font-medium border border-gray-200 focus:z-10 bg-gray-400 text-gray-600 mr-1 hover:bg-gray-500 hover:text-white transition"
                                          onClick={() => {
                                            openLinkSlipModal(m.mother_bag_code);
                                          }}
                                        >
                                          Link
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          className="inline-block rounded-md px-2 py-1 text-sm font-medium bg-black-900 border border-gray-200 focus:z-10 mr-1 text-white hover:bg-opacity-60 transition"
                                          onClick={() => {
                                            if (selectedMbagCodes.length > 0) {
                                              openLinkSlipModal(m.mother_bag_code);
                                            } else {
                                              const slipUrl = m?.VendorSlips?.length && get_file_url(m?.VendorSlips[m?.VendorSlips?.length - 1].slip_url);
                                              if (slipUrl) {
                                                window.open(slipUrl, "_blank");
                                              }
                                            }
                                          }}
                                        >
                                          Slip
                                        </button>
                                      )}
                                      <Button
                                        type="button"
                                        className="rounded-md px-2 py-1 text-sm font-medium text-white bg-black-900 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                                        onClick={() => printLabel(m)}
                                      >
                                        Print
                                      </Button>

                                    <Popover
                                      color="foreground"
                                      placement="bottom-end"
                                      onOpenChange={() => {
                                        setJioTagLocation({});
                                      }}
                                    >
                                      <PopoverTrigger asChild>
                                        <HeroButton
                                          size="sm"
                                          className="h-7 min-w-0 px-2 ml-1"
                                          color={m.refNo ? "primary" : "default"}
                                          variant="solid"
                                          disabled={!m.refNo}
                                        >
                                          Tag
                                        </HeroButton>
                                      </PopoverTrigger>
                                      <PopoverContent>
                                        <div className="font-inter">
                                          <div className="px-1 py-2 flex items-center gap-4">
                                            <div className="text-small font-bold uppercase">{m.refNo}</div>
                                            <HeroButton
                                              color="warning"
                                              size="sm"
                                              onPress={() => {
                                                loadMbagTagLocation({
                                                  url: "/admin/jio-location",
                                                  method: "GET",
                                                  data: { name: m.refNo },
                                                });
                                              }}
                                            >
                                              Load
                                            </HeroButton>
                                          </div>
                                          {(jioTagLocation?.google_maps_link || isLoadingMbagTagLocation) && (
                                            <div className="max-w-96">
                                              {isLoadingMbagTagLocation ? (
                                                <p>Loading...</p>
                                              ) : (
                                                <>
                                                  <p>
                                                    Link:{" "}
                                                    <a
                                                      className="underline text-yellow-400"
                                                      target="_blank"
                                                      href={jioTagLocation.google_maps_link}
                                                    >
                                                      Open Google Map
                                                    </a>
                                                  </p>
                                                  <p>Accuracy: {jioTagLocation.accuracy.toFixed(2)}m</p>
                                                  <p>
                                                    Elevation: {jioTagLocation.altitude}m / {(jioTagLocation.altitude * 3.28084).toFixed(0)}
                                                    ft
                                                  </p>
                                                  <p>Addr: <span className="text-[#03a9f4]">{jioTagLocation.latLongData?.display_name}</span></p>
                                                  <p>Time: {moment(jioTagLocation.time).format("DD-MM-YYYY HH:mm:ss")}</p>
                                                </>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </PopoverContent>
                                    </Popover>

                                    {/* Live Train Tracking Button */}
                                    {m.mawbStatus?.train_no && (
                                      <HeroButton
                                        size="sm"
                                        className="h-7 min-w-0 px-2 ml-1"
                                        color="success"
                                        variant="solid"
                                        onPress={() => setTrainTrackingModal({ isOpen: true, trainNo: m.mawbStatus.train_no, defaultDate: m.mawbStatus?.train_date })}
                                      >
                                        Live
                                      </HeroButton>
                                    )}
                                  </TableCell>
                                  <TableCell>{m.motherbad_pods && m.motherbad_pods.length > 0 && m.motherbad_pods[0].remark}</TableCell>
                                  <TableCell className="p-1 print:hidden rounded-r-md">
                                    <div className="relative inline-block">
                                      <button
                                        type="button"
                                        className="p-1 hover:bg-gray-200 rounded-full"
                                        onClick={() => setOpenActionMenu(openActionMenu === m.id ? null : m.id)}
                                      >
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                        </svg>
                                      </button>
                                      {openActionMenu === m.id && (
                                        <div className="absolute right-0 top-full mt-1 w-36 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                                          <button
                                            type="button"
                                            className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                                            onClick={() => {
                                              setStatusUpdateModal(m);
                                              setSelectedMotherbagStatus({ value: -1, label: "Select..." });
                                              setOpenActionMenu(null);
                                            }}
                                          >
                                            Status Update
                                          </button>
                                          <button
                                            type="button"
                                            className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 border-t"
                                            onClick={() => {
                                              // Prefill form with existing data
                                              const modeOption = modeOfPkgOptions.find((o: any) => o.value === m.modeOfPkg) || modeOfPkgOptions[0];
                                              const airlineOption = airlineOptions.find((o: any) => o.id === m.airline) || { id: 0, name: "Select Airline" };
                                              const vendorOption = vendorOptions.find((o: any) => o.id === m.vendor) || { id: 0, vendor_name: "Select Vendor" };
                                              const typeOption = typeOptions.find((o: any) => o.value === m.type) || typeOptions[0];
                                              const existingMawbStatus = m.mawbStatus || {};
                                              
                                              setEditInfoForm({
                                                modeOfPkg: modeOption,
                                                airline: airlineOption,
                                                flight: { id: m.flight || 0, name: "Select Flight" },
                                                vendor: vendorOption,
                                                mawb: m.mawb || "",
                                                train_no: existingMawbStatus.train_no || "",
                                                train_date: existingMawbStatus.train_date || "",
                                                dest_train_code: existingMawbStatus.dest_train_code || "",
                                                flight_track_no: existingMawbStatus.flight_track_no || "",
                                                type: typeOption,
                                                realWeight: m.realWeight || "",
                                                remark: m.remark || "",
                                                refNo: m.refNo || "",
                                              });
                                              
                                              // Fetch flights if airline is already selected
                                              if (m.airline) {
                                                fetchFlightsForEdit(m.airline);
                                              }
                                              
                                              setEditInfoModal(m);
                                              setOpenActionMenu(null);
                                            }}
                                          >
                                            Edit Info
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </TableCell>
                                </TableRow>
                              )
                          )}
                        </>
                      ))}
                    </TableBody>
                  </Table>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="px-6">
          <table className="border text-left px-4 rounded hidden">
            <thead className="border-b">
              <tr>
                <th className="py-2 px-2 print:hidden">-</th>
                <th className="px-1">Added On</th>
                <th className="px-1">Motherbag No</th>
                <th className="px-1">Origin</th>
                <th className="px-1">Destination</th>
                <th className="px-1">Mode</th>
                <th className="px-1">
                  No of
                  <br />
                  Awb
                </th>
                <th className="px-1">Total Weight</th>
                <th className="px-1">Status</th>
                <th className="px-1 print:hidden">Action</th>
                <th className="px-1 print:hidden">Last Reason</th>
                <th className="px-1 print:hidden">Reason</th>
              </tr>
            </thead>
            <tbody>
              {motherBagList.map((m) => {
                return (
                  doShowRow(m) && (
                    <tr
                      key={"tr-" + m.id}
                      className={`border-t ${m.id == selectedMotherbag && "bg-blue-200"} 
                    ${
                      m.status == "SHORT"
                        ? "bg-teal-600 text-white"
                        : m.inscanDone
                        ? "bg-green-500"
                        : m.outscanDone
                        ? "bg-yellow-100"
                        : "bg-red-400"
                    }`}
                    >
                      <td className="print:hidden">
                        {m.outscanDone ? (
                          <p className="py-1 px-1 text-sm">-</p>
                        ) : m.id == selectedMotherbag ? (
                          <p className="py-1 px-1 text-sm">Selcted</p>
                        ) : (
                          <>
                            <Button
                              type="button"
                              className="rounded-md px-2 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                              onClick={() => {
                                setSelectedMotherbag(m.id);
                                setSelectedMotherbagData(m);
                                resetForm();
                              }}
                            >
                              Select
                            </Button>

                            {!m.outscanDone && (
                              <Button
                                type="button"
                                className="rounded-md px-2 py-1 text-sm font-medium text-white bg-blue-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 ml-2"
                                onClick={() => {
                                  navigate("/mother_bag/add", {
                                    state: {
                                      mode: "edit",
                                      data: m,
                                    },
                                  });
                                }}
                              >
                                Edit
                              </Button>
                            )}
                          </>
                        )}
                      </td>
                      <td>{moment(m.createdAt, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm")}</td>
                      <td className="px-2 whitespace-nowrap">
                        <button
                          type="button"
                          onClick={async () => {
                            await navigator.clipboard.writeText(m.mother_bag_code || "-");
                            UseToast("Copied!");
                          }}
                        >
                          <DocumentDuplicateIcon className="h-5 -mb-1 mr-2" />
                        </button>
                        <span
                          className="cursor-pointer hover:underline font-semibold font-opensans"
                          onClick={() => {
                            navigate("/mother_bag/add", {
                              state: {
                                mode: "view",
                                data: m,
                              },
                            });
                          }}
                        >
                          {m.mother_bag_code}
                        </span>
                      </td>
                      <td>{m._subbranch?.branch_name}</td>
                      <td>
                        {(m._delivery_subbranch?.branch_name || m._destination?.city_name) === "NON-BRANCH" ? (
                          <div className="leading-tight">
                            <span className="text-[11px] font-semibold bg-orange-200 text-orange-800 px-1 rounded">NON-BRANCH</span>
                            <br />
                            <span className="font-semibold">{m._re_route_city?.city_name}</span>
                          </div>
                        ) : (
                          m._delivery_subbranch?.branch_name || m._destination?.city_name
                        )}
                      </td>
                      <td>{getModeSvg(m.modeOfPkg)}</td>
                      <td>{m.totalNos}</td>
                      <td>{Number(m.sysWeight).toFixed(2)}</td>
                      <td>{m.status == "SHORT" ? "Short" : m.inscanDone ? "Received" : m.outscanDone ? "Outscan" : "Pending"}</td>
                      <td className="text-center print:hidden whitespace-nowrap px-2">
                        {!m?.VendorSlips?.length ? (
                          <button
                            type="button"
                            className="inline-block rounded-md px-2 py-1 text-sm font-medium border border-gray-200 focus:z-10 bg-gray-400 text-gray-600 mr-1 hover:bg-gray-500 hover:text-white transition"
                            onClick={() => {
                              openLinkSlipModal(m.mother_bag_code);
                            }}
                          >
                            Link
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="inline-block rounded-md px-2 py-1 text-sm font-medium bg-black-900 border border-gray-200 focus:z-10 mr-1 text-white hover:bg-opacity-60 transition"
                            onClick={() => {
                              if (selectedMbagCodes.length > 0) {
                                openLinkSlipModal(m.mother_bag_code);
                              } else {
                                const slipUrl = m?.VendorSlips?.length && get_file_url(m?.VendorSlips[m?.VendorSlips?.length - 1].slip_url);
                                if (slipUrl) {
                                  window.open(slipUrl, "_blank");
                                }
                              }
                            }}
                          >
                            Slip
                          </button>
                        )}
                        <Button
                          type="button"
                          className="rounded-md px-2 py-1 text-sm font-medium text-white bg-black-900 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                          onClick={() => printLabel(m)}
                        >
                          Print
                        </Button>
                      </td>
                      <td>{m.motherbad_pods && m.motherbad_pods.length > 0 && m.motherbad_pods[0].remark}</td>
                      <td className="flex p-1 gap-1 max-w-[300px] print:hidden">
                        <Select
                          className={`flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block `}
                          options={motherbagStatusList}
                          value={selectedStatusValues[m.id] || ""}
                          onChange={(e) => {
                            setSelectedMotherbagStatus(e);
                            setSelectedStatusValues((prevState) => ({
                              ...prevState,
                              [m.id]: e,
                            }));
                          }}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "30px",
                              height: "30px",
                            }),
                            valueContainer: (provided, state) => ({
                              ...provided,
                              height: "30px",
                              padding: "0 6px",
                            }),
                            input: (provided, state) => ({
                              ...provided,
                              margin: "0px",
                            }),

                            indicatorsContainer: (provided, state) => ({
                              ...provided,
                              height: "30px",
                            }),
                          }}
                          menuPortalTarget={document.body}
                        />
                        <Button
                          type="button"
                          className="rounded-md px-2 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                          onClick={() => {
                            selectedStatusValues[m.id].value != -1 &&
                              addMotherbag_pod({
                                url: "/admin/motherbad_pod/create/",
                                data: {
                                  bagId: m.id,
                                  status: selectedStatusValues[m.id].value + "",
                                  remark: selectedStatusValues[m.id].label,
                                  dateTime: new Date(),
                                },
                              });
                          }}
                        >
                          Save
                        </Button>
                      </td>
                    </tr>
                  )
                );
              })}
            </tbody>
          </table>

          <div className="flex gap-2 flex-wrap border p-2 rounded-xl mt-4">
            <div className="w-full font-semibold underline">Motherbag Information</div>

            <div className="grid grid-cols-3 w-full mt-3">
              {getInput(ADT.DB, "Mode Of Package", { all: modeOfPkgOptions }, "modeOfPkg", isDisabled, "border-x border-[#000] px-2")}

              {getInput(
                ADT.DB,
                "Airline",
                { all: airlineOptions },
                "airline",
                isDisabled || values?.modeOfPkg?.value != "By Air",
                "border-x border-[#000] px-2",
                "id",
                "name"
              )}

              {getInput(
                ADT.DB,
                "Flight",
                { all: flightOptions },
                "flight",
                isDisabled || values?.modeOfPkg?.value != "By Air",
                "border-x border-[#000] px-2",
                "id",
                "name"
              )}

              {getInput(ADT.DB, "Vendor", { all: vendorOptions }, "vendor", isDisabled, "border-x border-[#000] px-2", "id", "vendor_name")}

              {false &&
                getInput(
                  ADT.DB,
                  "Delivery Vendor",
                  { all: deliVendorOptions },
                  "deliveryVendor",
                  isDisabled,
                  "border-x border-[#000] px-2",
                  "id",
                  "vendor_name"
                )}

              {getInput(ADT.TEXT, "MAWB_No", {}, "mawb", isDisabled, "border-x border-[#000] px-2")}

              {getInput(ADT.DB, "Type", { all: typeOptions }, "type", isDisabled, "border-x border-[#000] px-2")}
              {/*getInput(
                ADT.TEXT,
                "Weight",
                selectedMotherbagData.totalNos,
                "sysWeight",
                isDisabled,
                "border-x border-[#000] px-2"
              )*/}

              {getInput(ADT.TEXT, "Actual_Weight", {}, "realWeight", isDisabled, "border-x border-[#000] px-2")}

              {/*getInput(
                ADT.TEXT,
                "Total Pieces",
                {},
                "totalNos",
                true,
                "border-x border-[#000] px-2"
              )*/}

              {getInput(ADT.TEXT, "Remark", {}, "remark", isDisabled, "border-x border-[#000] px-2")}

              <button
                type="button"
                className="text-lg font-semibold bg-primary text-white px-4 py-1 rounded-md m-2"
                onClick={() => {
                  openLinkSlipModal();
                }}
              >
                Link MAWB Slip
              </button>
            </div>
            <div className="flex w-full justify-end">
              <Button
                type="submit"
                className="rounded-md inline-block px-4 py-2 text-sm font-medium text-white bg-blue-800 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
              >
                Outscan
              </Button>
            </div>
          </div>
        </div>
      </form>

      {/* Status Update Modal */}
      {statusUpdateModal && (
        <div className="fixed inset-0 bg-black-900 bg-opacity-50 flex items-start justify-center pt-20 z-50 font-inter overflow-auto" onClick={() => setStatusUpdateModal(null)}>
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl font-bold"
              onClick={() => setStatusUpdateModal(null)}
            >
              &times;
            </button>

            <h2 className="text-lg font-bold mb-4 border-b pb-2">Update Motherbag Status</h2>

            {/* Motherbag Details for verification */}
            <div className="bg-gray-50 rounded-md p-3 mb-4 text-sm space-y-1">
              <div className="flex justify-between">
                <span className="text-gray-600">Motherbag No:</span>
                <span className="font-semibold">{statusUpdateModal.mother_bag_code}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Origin:</span>
                <span className="font-medium">{statusUpdateModal._subbranch?.branch_name}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Destination:</span>
                <span className="font-medium">
                  {(statusUpdateModal._delivery_subbranch?.branch_name || statusUpdateModal._destination?.city_name) === "NON-BRANCH"
                    ? <>{statusUpdateModal._re_route_city?.city_name} <span className="text-[11px] font-semibold bg-orange-200 text-orange-800 px-1 rounded ml-1">(NON-BRANCH)</span></>
                    : statusUpdateModal._delivery_subbranch?.branch_name || statusUpdateModal._destination?.city_name}
                </span>
                <span className="font-medium">
                  {statusUpdateModal.status == "SHORT" ? "Short" : statusUpdateModal.inscanDone ? "Received" : statusUpdateModal.outscanDone ? "Outscan" : "Pending"}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Total Nos:</span>
                <span className="font-medium">{statusUpdateModal.totalNos}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Total Weight:</span>
                <span className="font-medium">{Number(statusUpdateModal.sysWeight).toFixed(2)}</span>
              </div>
            </div>

            {/* Status Dropdown */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">New Status</label>
              <Select
                className="bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
                options={motherbagStatusList}
                value={selectedMotherbagStatus}
                onChange={(e) => setSelectedMotherbagStatus(e)}
                placeholder="Select status..."
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            {/* Save Button */}
            <div className="flex justify-end gap-2">
              <Button
                type="button"
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={() => setStatusUpdateModal(null)}
              >
                Cancel
              </Button>
              <Button
                type="button"
                className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
                onClick={() => {
                  if (!selectedMotherbagStatus?.value || selectedMotherbagStatus.value === -1) {
                    UseToast("Please select a status", "error");
                    return;
                  }
                  addMotherbag_pod({
                    url: "/admin/motherbad_pod/create/",
                    data: {
                      bagId: statusUpdateModal.id,
                      status: selectedMotherbagStatus.value + "",
                      remark: selectedMotherbagStatus.label,
                      dateTime: new Date(),
                    },
                  });
                  setStatusUpdateModal(null);
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Info Modal */}
      {editInfoModal && (
        <div className="fixed inset-0 bg-black-900 bg-opacity-50 flex items-start justify-center pt-10 z-[9999] font-inter overflow-auto" onClick={() => setEditInfoModal(null)}>
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative mb-10" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl font-bold"
              onClick={() => setEditInfoModal(null)}
            >
              &times;
            </button>

            <h2 className="text-lg font-bold mb-4 border-b pb-2">Edit Motherbag Info</h2>

            {/* Motherbag Details for verification */}
            <div className="bg-gray-50 rounded-md p-3 mb-4 text-sm space-y-1">
              <div className="flex justify-between">
                <span className="text-gray-600">Motherbag No:</span>
                <span className="font-semibold">{editInfoModal.mother_bag_code}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Origin:</span>
                <span className="font-medium">{editInfoModal._subbranch?.branch_name}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Destination:</span>
                <span className="font-medium">
                  {(editInfoModal._delivery_subbranch?.branch_name || editInfoModal._destination?.city_name) === "NON-BRANCH"
                    ? <>{editInfoModal._re_route_city?.city_name} <span className="text-[11px] font-semibold bg-orange-200 text-orange-800 px-1 rounded ml-1">(NON-BRANCH)</span></>
                    : editInfoModal._delivery_subbranch?.branch_name || editInfoModal._destination?.city_name}
                </span>
              </div>
            </div>

            {/* Edit Form */}
            <div className="space-y-3">
              {/* Mode Of Package */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mode Of Package</label>
                <Select
                  className="bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
                  options={modeOfPkgOptions}
                  value={editInfoForm.modeOfPkg}
                  onChange={(e) => {
                    setEditInfoForm({ ...editInfoForm, modeOfPkg: e, train_no: "", flight: { id: 0, name: "Select Flight" } });
                    if (e?.value === "By Road" || e?.value === "By Train") {
                      setEditInfoForm((prev: any) => ({ ...prev, modeOfPkg: e, airline: { id: 1010, name: "BY ROAD" }, train_no: "", flight: { id: 1016, name: "0" } }));
                    }
                  }}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                />
              </div>

              {/* Airline - Only show for By Air */}
              {editInfoForm.modeOfPkg?.value === "By Air" && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Airline</label>
                  <Select
                    className="bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
                    options={airlineOptions}
                    getOptionValue={(x) => x.id}
                    getOptionLabel={(x) => x.name}
                    value={editInfoForm.airline}
                    onChange={(e) => {
                      setEditInfoForm({ ...editInfoForm, airline: e, flight: { id: 0, name: "Select Flight" } });
                      if (e?.id) fetchFlightsForEdit(e.id);
                    }}
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                  />
                </div>
              )}

              {/* Flight - Only show for By Air */}
              {editInfoForm.modeOfPkg?.value === "By Air" && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Flight</label>
                  <Select
                    className="bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
                    options={editFlightOptions}
                    getOptionValue={(x) => x.id}
                    getOptionLabel={(x) => x.name}
                    value={editFlightOptions.find((f) => f.id === editInfoForm.flight?.id) || editInfoForm.flight}
                    onChange={(e) => setEditInfoForm({ ...editInfoForm, flight: e })}
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                  />
                </div>
              )}

              {/* Flight Track No - Only show for By Air */}
              {editInfoForm.modeOfPkg?.value === "By Air" && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Flight Track No</label>
                  <input
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder="Enter Flight Track Number"
                    value={editInfoForm.flight_track_no}
                    onChange={(e) => setEditInfoForm({ ...editInfoForm, flight_track_no: e.target.value })}
                  />
                </div>
              )}

              {/* Train No - Only show for By Train */}
              {editInfoForm.modeOfPkg?.value === "By Train" && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Train No</label>
                  <input
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder="Enter Train Number"
                    value={editInfoForm.train_no}
                    onChange={(e) => setEditInfoForm({ ...editInfoForm, train_no: e.target.value })}
                  />
                </div>
              )}

              {/* Train Date - Only show for By Train */}
              {editInfoForm.modeOfPkg?.value === "By Train" && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Train Date</label>
                  <input
                    type="date"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    value={editInfoForm.train_date}
                    onChange={(e) => setEditInfoForm({ ...editInfoForm, train_date: e.target.value })}
                  />
                </div>
              )}

              {/* Dest Train Code - Only show for By Train */}
              {editInfoForm.modeOfPkg?.value === "By Train" && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Dest Train Code</label>
                  <input
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder="Enter Destination Train Code"
                    value={editInfoForm.dest_train_code}
                    onChange={(e) => setEditInfoForm({ ...editInfoForm, dest_train_code: e.target.value })}
                  />
                </div>
              )}

              {/* Vendor */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Vendor</label>
                <Select
                  className="bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
                  options={vendorOptions}
                  getOptionValue={(x) => x.id}
                  getOptionLabel={(x) => x.vendor_name}
                  value={editInfoForm.vendor}
                  onChange={(e) => setEditInfoForm({ ...editInfoForm, vendor: e })}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                />
              </div>

              {/* MAWB No */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MAWB No</label>
                <input
                  type="text"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  placeholder="Enter MAWB Number"
                  value={editInfoForm.mawb}
                  onChange={(e) => setEditInfoForm({ ...editInfoForm, mawb: e.target.value })}
                />
              </div>

              {/* Type */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
                <Select
                  className="bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
                  options={typeOptions}
                  value={editInfoForm.type}
                  onChange={(e) => setEditInfoForm({ ...editInfoForm, type: e })}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                />
              </div>

              {/* Actual Weight */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Actual Weight</label>
                <input
                  type="text"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  placeholder="Enter Actual Weight"
                  value={editInfoForm.realWeight}
                  onChange={(e) => setEditInfoForm({ ...editInfoForm, realWeight: e.target.value })}
                />
              </div>

              {/* Tag Id */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tag Id</label>
                <input
                  type="text"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  placeholder="Enter Tag Id"
                  value={editInfoForm.refNo}
                  onChange={(e) => setEditInfoForm({ ...editInfoForm, refNo: e.target.value })}
                />
              </div>

              {/* Remark */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Remark</label>
                <input
                  type="text"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  placeholder="Enter Remark"
                  value={editInfoForm.remark}
                  onChange={(e) => setEditInfoForm({ ...editInfoForm, remark: e.target.value })}
                />
              </div>
            </div>

            {/* Save Button */}
            <div className="flex justify-end gap-2 mt-6">
              <Button
                type="button"
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={() => setEditInfoModal(null)}
              >
                Cancel
              </Button>
              <Button
                type="button"
                className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
                onClick={() => {
                  // Build mawbStatus JSON
                  const existingMawbStatus = editInfoModal.mawbStatus || {};
                  const mawbStatus = {
                    ...existingMawbStatus,
                    train_no: editInfoForm.modeOfPkg?.value === "By Train" ? editInfoForm.train_no : undefined,
                    train_date: editInfoForm.modeOfPkg?.value === "By Train" ? editInfoForm.train_date : undefined,
                    dest_train_code: editInfoForm.modeOfPkg?.value === "By Train" ? editInfoForm.dest_train_code : undefined,
                    flight_track_no: editInfoForm.modeOfPkg?.value === "By Air" ? editInfoForm.flight_track_no : undefined,
                  };

                  updateMotherbagInfo({
                    url: "/admin/mother_bag/update/" + editInfoModal.id,
                    data: {
                      modeOfPkg: editInfoForm.modeOfPkg?.value,
                      airline: editInfoForm.airline?.id || undefined,
                      flight: editInfoForm.flight?.id || undefined,
                      vendor: editInfoForm.vendor?.id || undefined,
                      mawb: editInfoForm.mawb || undefined,
                      type: editInfoForm.type?.value,
                      realWeight: editInfoForm.realWeight || undefined,
                      refNo: editInfoForm.refNo || undefined,
                      remark: editInfoForm.remark || undefined,
                      mawbStatus: mawbStatus,
                    },
                  });
                }}
              >
                {isUpdatingMotherbagInfo ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Train Tracking Modal */}
      <TrainTrackingModal
        isOpen={trainTrackingModal.isOpen}
        onClose={() => setTrainTrackingModal({ isOpen: false, trainNo: "" })}
        trainNo={trainTrackingModal.trainNo}
        defaultDate={trainTrackingModal.defaultDate}
      />

      {/* Click outside to close action menu */}
      {openActionMenu && (
        <div className="fixed inset-0 z-40" onClick={() => setOpenActionMenu(null)} />
      )}
    </>
  );
};

export default MotherBagOutScan;
